export const RQ_STATUS = {
  idle: 'idle',
  sending: 'sending',
  success: 'success',
  error: 'error'
};